import { Buttons, FlexContainer, Notification, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useScreen from 'Hooks/useScreen';
import useTranslation from 'Hooks/useTranslation';
import { useGetUserPlan } from 'Containers/Validations/hooks';
import { routes } from 'Constants/routes';
import { FRONT_PLANS } from 'Constants/plans';
import { ScreenPropsType } from 'Types/common';
import * as Styled from './styles';

const StartScreen = ({ screenName }: ScreenPropsType): JSX.Element => {
  const { renderForm, onNextScreen } = useScreen(screenName);
  const plan = useGetUserPlan();
  const { header, subheader, upsellingInfo, imageUrl } = renderForm;
  const { t } = useTranslation();
  const handleOnClick = (): void => history.push(routes.PLANS);
  const isBasicUser = plan === FRONT_PLANS.BASIC;

  return (
    <Styled.ValidationContent type="start">
      <Styled.Container direction="column" align="center" gap="dimension_24">
        <FlexContainer
          direction="column"
          align="center"
          justify="center"
          fullHeight
          gap="dimension_20"
        >
          {imageUrl && <Styled.ImageContainer src={imageUrl} alt="start-img" />}
          <Text type="paragraphs" size="XL_L_S" color="dark" align="center">
            {header}
          </Text>
        </FlexContainer>
        {upsellingInfo && subheader && (
          <Notification
            mode="light"
            title={subheader}
            description={upsellingInfo}
            id={`${screenName}_upselling`}
            buttonLabel={t(`${locizeNS.PLANS}:UpsellingCard.CTA`)}
            buttonOnClick={isBasicUser ? handleOnClick : undefined}
            noClose
            mb="fds_size_40"
          />
        )}
        <Styled.ButtonsContainer fullWidth justify="center">
          <Buttons.Classic
            mode="primary"
            size="m"
            label={t('Button.continue')}
            testID="continueButton"
            onClick={onNextScreen}
          />
        </Styled.ButtonsContainer>
      </Styled.Container>
    </Styled.ValidationContent>
  );
};

export default StartScreen;
